import { getUserSessionData } from '../../utils/userSession';
import backendAPIClient from '../apiClient';

const user = getUserSessionData();

export const getWorkflows = async (params) => {
    return backendAPIClient
        .get(`/n8n/workflows?active=true`, {
            params,
            headers: {
                Authorization: `Bearer ${user?.accessToken}`,
            },
        })
        .then((res) => res.data)
        .catch((err) => Promise.reject({ ...err }));
};

export const deleteWorkflow = async (workflowId: string) => {
    return backendAPIClient
        .delete(`/n8n/workflows/${workflowId}`, {
            headers: {
                Authorization: `Bearer ${user?.accessToken}`,
            },
        })
        .then((res) => res.data)
        .catch((err) => Promise.reject({ ...err }));
};
